module.exports = __webpack_public_path__ + "static/img/remark-video.e7b7531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/remark-video.png
// module id = dpXS
// module chunks = 1